const getCopyright = (httpClient) => {
    return httpClient.get(`settings/copyright`)
    .then(res => res.data)
}

const updateCopyright = (httpClient, copyright) => {
  return httpClient.patch(`settings/copyright`, copyright)
    .then(res => res.data)
}

 const  updateLicenseOnline = (httpClient, license) => {
  return httpClient.post(`settings/active_online`, license)
  .then(res => res.data)
}

const updateLicenseOffline = (httpClient, license) => {
  return httpClient.post(`settings/active_offline`, license)
    .then(body => {
      return body.data
    })
}

const scheduleUpdate = (httpClient, schedule) => {
  return httpClient.patch(`settings/schedule_update`, schedule)
    .then(res => res.data)
}

const getScheduleUpdate = (httpClient) => {
  return httpClient.get(`settings/schedule_update`)
    .then(res => res.data)
}

const  checkConnection =  (httpClient) =>  {
  return httpClient.post(`settings/check_connect`)
  .then(res => res.data)
}

  export default {
    getCopyright,
    updateCopyright,
    updateLicenseOnline,
    updateLicenseOffline,
    scheduleUpdate,
    checkConnection,
    getScheduleUpdate
  }
  